import React from 'react';

import cn from 'classnames';

import bem from 'client/services/bem';

import RadioInput, {RadioInputColors} from '../radio-input';

import './radio-group-input.scss';

const b = bem('radio-group-input');

export type RadioGroupOption = {
  label: React.ReactNode;
  value: string;
  disabled?: boolean;
  exclude?: boolean;
  children?: React.ReactNode;
};

export type RadioGroupProps = {
  /** @deprecated Use classNames */
  classNameOption?: string;
  name?: string;
  disabled?: boolean;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
  color?: RadioInputColors;
  options: RadioGroupOption[];
  direction?: 'horizontal' | 'vertical';
  asButton?: boolean;
  legend?: React.ReactNode;
  classNames?: {
    option?: string;
    legend?: string;
  };
};

const RadioGroupInput: React.FC<RadioGroupProps> = (props) => {
  const {
    classNameOption = '',
    name = '',
    disabled = false,
    value = '',
    onChange,
    className,
    color = 'primary',
    options,
    direction = 'vertical',
    asButton = false,
    legend = '',
    classNames,
  } = props;

  const commonRadioInput = (opt: RadioGroupOption) => {
    return (
      <RadioInput
        name={name}
        value={opt.value}
        label={opt.label}
        checked={value === opt.value}
        key={opt.value}
        disabled={disabled || opt.disabled}
        className={cn(classNameOption, classNames?.option, b('option'))}
        color={color}
        asButton={asButton}
        onChange={onChange}
      />
    );
  };
  return (
    <fieldset name={name} className={cn(b([direction]), className)} disabled={disabled}>
      {legend && <legend className={cn(b('legend'), classNames?.legend)}>{legend}</legend>}

      {options.map(
        (opt) =>
          !opt.exclude &&
          (opt?.children ? (
            <div className={b('wrapper')} key={opt.value}>
              {commonRadioInput(opt)}
              {opt?.children}
            </div>
          ) : (
            commonRadioInput(opt)
          )),
      )}
    </fieldset>
  );
};

export default RadioGroupInput;
